import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  addToWishlist,
  removeFromWishlist,
} from "../../redux/actions/wishlist";
import { useToast } from "../Layout/Toast/ToastProvider.jsx";
import { addTocart } from "../../redux/actions/cart";
import {
  AiFillHeart,
  AiOutlineHeart,
  AiOutlineShoppingCart,
} from "react-icons/ai";

import "./ProductCard.scss";

const ProductCard = ({ data, isEvent }) => {
  const { wishlist } = useSelector((state) => state.wishlist);
  const { cart } = useSelector((state) => state.cart);
  const [click, setClick] = useState(false);
  const [animate, setAnimate] = useState(false);
  const dispatch = useDispatch();
  const { showToast } = useToast();

  useEffect(() => {
    if (wishlist && wishlist.find((i) => i._id === data._id)) {
      setClick(true);
    } else {
      setClick(false);
    }
  }, [wishlist, data._id]);

  const removeFromWishlistHandler = (product) => {
    setClick(!click);
    dispatch(removeFromWishlist(product));
  };

  const addToWishlistHandler = (product) => {
    setAnimate(true);
    setClick(!click);
    dispatch(addToWishlist(product));
    setTimeout(() => setAnimate(false), 400);
  };

  const addToCartHandler = (id) => {
    const itemIndex = cart.findIndex((i) => i._id === id);

    if (itemIndex !== -1) {
      const updatedItem = {
        ...cart[itemIndex],
        qty: cart[itemIndex].qty + 1,
      };
      dispatch(addTocart(updatedItem, itemIndex));
      showToast("Кількість товару в корзині збільшена!", "success");
    } else {
      const cartData = { ...data, qty: 1 };
      dispatch(addTocart(cartData));
      showToast("Продукт успішно додано до корзини!", "success");
    }
  };

  function formatPrice(price, maxDigits = 7) {
    if (typeof price !== "number" || isNaN(price)) {
      return "";
    }
    const digits = Math.floor(Math.log10(price)) + 1;

    if (digits > maxDigits) {
      const shortenedNumber = Math.floor(
        price / Math.pow(10, digits - maxDigits)
      );

      return shortenedNumber.toLocaleString("uk-UA") + "...";
    }

    return price.toLocaleString("uk-UA");
  }

  return (
    <div className="product-card">
      <Link
        to={
          isEvent ? `/product/${data._id}?isEvent=true` : `/product/${data._id}`
        }
        className="link"
      >
        <h4 className="product-title">
          {data.name.length > 40 ? data.name.slice(0, 40) + "..." : data.name}
        </h4>
        <div className="price">
          <div className="pricecont">
            {data.discountPrice ? (
              <>
                <h5 className="product-price">
                  {formatPrice(data.discountPrice, 7)} грн
                </h5>
                {data.originalPrice &&
                  data.originalPrice !== data.discountPrice && (
                    <h4 className="discount">
                      {formatPrice(data.originalPrice, 6)} грн
                    </h4>
                  )}
              </>
            ) : (
              <h5 className="product-price">
                {formatPrice(data.originalPrice, 7)} грн
              </h5>
            )}
          </div>
        </div>

        <img
          src={data.images && data.images[0]?.url}
          alt="Product"
          className="product-image"
          onError={(e) => (e.target.src = "/placeholder-image.jpg")}
        />
      </Link>
      <div className="cont">
        <button
          className="btn-add-to-cart"
          onClick={() => addToCartHandler(data._id)}
        >
          <span className="butmob">
            <AiOutlineShoppingCart size={13} />
          </span>
          <span className="butdesc">В кошик</span>
        </button>

        {click ? (
          <AiFillHeart
            size={22}
            className={`heart-icon ${click ? "active" : ""} ${
              animate ? "animate" : ""
            }`}
            onClick={() => removeFromWishlistHandler(data)}
            title="Remove from wishlist"
          />
        ) : (
          <AiOutlineHeart
            size={22}
            className={`heart-icon ${animate ? "animate" : ""}`}
            onClick={() => addToWishlistHandler(data)}
            title="Add to wishlist"
          />
        )}
      </div>
    </div>
  );
};

export default ProductCard;
